/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_Table_LabelInputs */

const en_wb_operations_table_label = /** @type {(inputs: Wb_Operations_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example order details`)
};

const lv_wb_operations_table_label = /** @type {(inputs: Wb_Operations_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasūtījuma detaļu piemērs`)
};

/**
* | output |
* | --- |
* | "Example order details" |
*
* @param {Wb_Operations_Table_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_table_label = /** @type {((inputs?: Wb_Operations_Table_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_Table_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_table_label(inputs)
	return en_wb_operations_table_label(inputs)
});